import { MoreOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import MenuItem from "Components/NavBar/MenuItem";
import { loadZohoBot, unloadZohoBot } from "Components/NavBar/useZohoBot";
import React from "react";
import { useNavigate } from "react-router-dom";
import { UserInfoContext } from "Context/CommonContext";
import { useAuth } from "utilFunctions/CustomHooks/useAuth";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";
import LogoutIcon from "Assets/Icons/LogoutIcon";
import Typography from "Components/CommonComponents/Typography";

const menuStyle: React.CSSProperties = {
  position: "absolute",
  top: "calc(100% + 8px)",
  right: 0,
  display: "flex",
  flexDirection: "column",
  gap: 8,
  padding: "10px 12px",
  background: "#fff",
  backdropFilter: "blur(12px)",
  borderRadius: 12,
  boxShadow: "0 8px 32px rgba(0,0,0,0.28)",
  border: "1px solid rgba(255,255,255,0.10)",
  zIndex: 1000,
  minWidth: 56,
  color: "var(--primary-text)",
  cursor: "pointer",
};

export interface MenuItemIF {
  label: string;
  id: number;
  key?: number;
}

interface MoreButtonProps {
  onProfileClick: () => void;
  onLogout: () => void;
}

const MenuItemList: MenuItemIF[] = [
  { label: "Home", id: 1 },
  { label: "Profile", id: 2 },
  { label: "Help", id: 3 },
];

const MoreButton: React.FC<MoreButtonProps> = () => {
  const [open, setOpen] = React.useState(false);
  const [showProfile, setShowProfile] = React.useState(false);
  const [isHelpCenterActive, setIsHelpCenterActive] = React.useState(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const userInfo = React.useContext<any>(UserInfoContext);
  const { logout } = useAuth();

  const handleHelpCenterToggle = () => {
    const newState = !isHelpCenterActive;
    setIsHelpCenterActive(newState);
    if (newState) {
      loadZohoBot();
    } else {
      unloadZohoBot();
    }
  };

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onMenuClickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    const id = Number((event.target as HTMLElement).id);
    if (id === 1) {
      setOpen(false);
      navigate("/admin/dashboard");
      return;
    }
    if (id === 2) {
      setShowProfile(true);
      return;
    }
    if (id === 3) {
      setOpen(false);
      handleHelpCenterToggle();
      return;
    }
  };

  const routeToMyProfile = () => {
    navigate("/admin/faculties/" + userInfo?.id, {
      replace: false,
      state: { faculty: userInfo, selectedDefaultTab: "2" },
    });
    setOpen(false);
    setShowProfile(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    logout();
  };

  return (
    <div
      ref={wrapperRef}
      style={{ position: "relative", display: "inline-flex" }}
    >
      <MoreOutlined
        style={{ fontSize: 18, color: "#fff" }}
        onClick={() => {
          setOpen((prev) => !prev);
          setShowProfile(false);
        }}
      />

      {open && !showProfile && (
        <div style={menuStyle} onClick={onMenuClickHandler}>
          {MenuItemList.map((item) => (
            <MenuItem key={item.id} item={item} />
          ))}
        </div>
      )}

      {open && showProfile && (
        <div style={{ ...menuStyle, minWidth: 200, gap: 0, padding: "12px" }}>
          {/* Back button */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              marginBottom: 12,
              cursor: "pointer",
              color: "#555",
              fontSize: 13,
            }}
            onClick={() => setShowProfile(false)}
          >
            <ArrowLeftOutlined style={{ fontSize: 12 }} />
            Back
          </div>

          {/* Profile info */}
          <div style={{ cursor: "pointer" }} onClick={routeToMyProfile}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 8,
              }}
            >
              <span className="profileDivWithName">
                {userInfo?.name &&
                  capitalizeFirstCharaterOfString(userInfo.name)}
              </span>
              <div>
                <Typography variant="h6" color="info">
                  {userInfo?.name}
                </Typography>
                <Typography variant="label" color="gray">
                  {userInfo?.email}
                </Typography>
              </div>
            </div>
          </div>

          <div style={{ borderTop: "1px solid #f0f0f0", marginTop: 4 }} />

          {/* Logout */}
          <div
            className="mt-1 pt-2 pb-1 logoutcss"
            style={{ cursor: "pointer" }}
            onClick={handleLogout}
          >
            <div className="logoutTitle mr-2">Logout</div>
            <div>
              <LogoutIcon />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MoreButton;
